export default {
  empty_no_value: "No value",
  empty_no_location: "No location",
  empty_no_deadline: "No deadline",
  empty_no_model: "No model",
  empty_incompatible: "Incompatible",
  empty_none: "None",
  object_page: "objects per page",
  menu_search: "Search",
  menu_none: "None Found",
  menu_search_column: "Search in {column}",
  state_work_order: "State",
  state_dropdown: "State",
  state_sort_by: "Sort State by",
  state_latest: "Latest",
  state_unreviewed: "Unreviewed",
  state_not_applicable: "Not applicable",
  state_accepted: "Accepted",
  state_rejected: "Rejected",
  state_oldest: "Oldest",
  state_overdue: "Overdue",
  state_behind: "Behind",
  state_resource: "Resource",
  state_draft: "Draft",
  state_in_progress: "In progress",
  state_open: "Open",
  state_complete: "Complete",
  state_planned: "Planned",
  state_complete_closed: "Closed",
  state_closed: "Closed",
  state_unknown: "Unknown",
  status_dropdown: "Status",
  status_sort_by: "Sort Status by",
  status_issue: "Issue Priority",
  status_work_order: "Work Order Priority",
  status_change_request: "Change Requests Amount",
  status_issue_overdue: "Deadline for correction",
  status_done: "Corrective Work Accepted",
  status_corrective_work: "Corrective Work",
  status_corrective_work_accepted: "Corrective Work accepted",
  status_closed: "Closed",
  entity_item: "Item | Items",
  entity_issue: "Issue | Issues",
  entity_model: "Model | Models",
  entity_performed_work: "Performed Work | Performed Works",
  entity_area: "Area | Areas",
  entity_layout: "Layout | Layouts",
  entity_workspace: "Workspace | Workspaces",
  entity_zone: "Zone | Zones",
  entity_work_order: "Work Order | Work Orders",
  entity_work_order_corrective: "Work Order Corrective",
  entity_work_order_regular: "Work Order Regular",
  entity_attachment: "Attachment | Attachments",
  entity_location: "Location | Locations",
  selection_all: "Select All",
  selection_none: "Select None",
  selection_not_included: "Not included",
  selection_included: "Included",
  selection_included_and_performed: "Included and Performed",
  selection_select_all_applicable: "Select all applicable",
  selection_deselect_all_applicable: "Deselect all applicable",
  selection_current_count:
    "<b>{current}</b> applicable <b class='text-info'>{entity}</b> selected.",
  toggle_to_do: "{entity} to do",
  toggle_performed: "Performed",
}
